import React from 'react';
import { getIntl } from '../../../../../../utils/intl';
import { ActionButtonLayout } from '../../../../../v2BaseComponents/ActionButtonLayout';
import Stack, { contentStackSpacing } from '../../../../../v2BaseComponents/Stack';
import Text from '../../../../../v2BaseComponents/Text';
import { salesEmail, scheduleACallUrl } from '../../../../../../utils/constants';
import MainContentContainer from '../../../../../v2BaseComponents/MainContentContainer';
import * as Linking from 'expo-linking';
import SubscriptionPlanDetails from '../../../../../shared/SubscriptionPlanDetails';

const intl = getIntl('SubscriptionTab', {
    professionalHeader: 'Professional',
    professionalSubHeader: 'Perfect for small businesses looking to efficiently scale care coordination',
    professionalPrice: '$250',
    professionalSubPrice: '/mo - $3,000 yr.',
    professionalFeature1: 'Unlimited Team Members',
    professionalFeature2: 'Co-Branded Experience',
    professionalFeature3: 'Custom Resource Templates',
    professionalFeature4: 'Easy Customization',
    professionalFeature5: 'Centralized Communication',
    professionalFeature6: 'Scale with Clients not Internal Users',
    professionalFeature7: 'Client Connection fee of $7/client/mo.',
    enterpriseHeader: 'Enterprise',
    enterpriseSubHeader: 'Perfect for businesses managing care coordination across thousands of clients',
    enterprisePrice: 'Custom',
    enterpriseSubPrice: 'Volume Discounts',
    enterpriseFeature1: 'Everything in Pro, Plus:',
    enterpriseFeature2: 'Dedicated Support',
    enterpriseFeature3: 'Custom CRM Integrations',
    enterpriseFeature4: 'Custom Reporting',
    enterpriseFeature5: 'Discounted Client Connection Fees',
    emailSubject: 'Primary Record Professional Inquiry',
    emailBody: 'Hello, I am interested in learning more about your services.',
    professionalSubscriptionPlans: 'With Scalable Pricing for Expanding Needs',
    contactUs: 'Contact Us',
    scheduleACall: 'Schedule a Call',
});

export type SubscriptionTabOwnProps = {};

export type SubscriptionTabProps = SubscriptionTabOwnProps;

const SubscriptionTab: React.FC<SubscriptionTabProps> = () => {
    return (
        <ActionButtonLayout
            scrollable
            whiteBackground
            actions={[
                {
                    title: intl('contactUs'),
                    onPress: () => {
                        Linking.openURL(
                            `mailto:${salesEmail}?subject=${encodeURIComponent(
                                intl('emailSubject'),
                            )}&body=${encodeURIComponent(intl('emailBody'))}`,
                        ).catch(() => {
                            console.error('Failed to open email');
                        });
                    },
                    variant: 'primary',
                    icon: 'Mail',
                    testID: 'org-billing-contact-us-button',
                },
            ]}
        >
            <MainContentContainer>
                <Stack vertical space={contentStackSpacing} align="center">
                    <Stack horizontal fullWidth justify="flex-start" style={{ maxWidth: 600 }}>
                        <Text variant="bold-h4" alignText="center" style={{ width: '100%' }}>
                            {intl('professionalSubscriptionPlans')}
                        </Text>
                    </Stack>
                    <Stack
                        horizontal
                        space={contentStackSpacing}
                        align="flex-start"
                        justify="center"
                        style={{ flexWrap: 'wrap' }}
                    >
                        <SubscriptionPlanDetails
                            style={{ height: '100%' }}
                            header={intl('professionalHeader')}
                            features={[
                                intl('professionalFeature1'),
                                intl('professionalFeature2'),
                                intl('professionalFeature4'),
                                intl('professionalFeature5'),
                                intl('professionalFeature6'),
                            ]}
                            actionButtonText={intl('scheduleACall')}
                            onActionButtonPress={() => {
                                Linking.openURL(scheduleACallUrl).catch(() => {
                                    console.error('Failed to open calendly');
                                });
                            }}
                        />
                        <SubscriptionPlanDetails
                            style={{ height: '100%' }}
                            header={intl('enterpriseHeader')}
                            features={[
                                intl('enterpriseFeature1'),
                                intl('enterpriseFeature2'),
                                intl('enterpriseFeature3'),
                                intl('enterpriseFeature4'),
                                intl('enterpriseFeature5'),
                            ]}
                            actionButtonText={intl('scheduleACall')}
                            onActionButtonPress={() => {
                                Linking.openURL(scheduleACallUrl).catch(() => {
                                    console.error('Failed to open calendly');
                                });
                            }}
                        />
                    </Stack>
                </Stack>
            </MainContentContainer>
        </ActionButtonLayout>
    );
};

export default React.memo(SubscriptionTab);
